
var songs = document.querySelectorAll('[data-song]');

function metadataHasLoaded() {
    let loadedElm = event.currentTarget.closest('.music-player');
    let progress = loadedElm.querySelector('[data-progress]');
    let song = loadedElm.querySelector('[data-song]');
    
    progress.max = song.duration;
    progress.value = song.currentTime;
}

function playPause() {
  console.log('playPause1')
    let clickedElm = event.currentTarget.closest('.music-player');
    let progress = clickedElm.querySelector('[data-progress]');
    let song = clickedElm.querySelector('[data-song]');
    let ctrlIcon = clickedElm.querySelector('[data-ctrlIcon]');
    let waveElm = clickedElm.querySelector('.sound-icon');
  
  if (ctrlIcon.classList.contains('fa-pause')) {
    song.pause();
    ctrlIcon.classList.remove('fa-pause');
    ctrlIcon.classList.add('fa-play');
  }
  else {
    songs.forEach(audio => {
      audio.pause();
      var icon = audio.parentElement.querySelector('[data-ctrlIcon]')
      if(icon.classList.contains('fa-pause')) {
        icon.classList.remove('fa-pause');
        icon.classList.add('fa-play');
      }
    })
    song.play();
    ctrlIcon.classList.remove('fa-play');
    ctrlIcon.classList.add('fa-pause');

    var max = setTimeout(function(){ /* Empty function */ },1);
    for (let i = 1; i < max; i++) {
      window.clearInterval(i);
    }
    setInterval(() => {
      progress.value = song.currentTime;
    },300)
  }
  console.log('playPause 2')
  toggleSoundWaveAnimation(waveElm);
}

function handleChange() {
  console.log('handleChange')
    let changedElm = event.currentTarget.closest('.music-player');
    let progress = changedElm.querySelector('[data-progress]');
    let song = changedElm.querySelector('[data-song]');
    let ctrlIcon = changedElm.querySelector('[data-ctrlIcon]');
    let waveElm = changedElm.querySelector('.sound-icon');

    songs.forEach(audio => {
      audio.pause();
      var icon = audio.parentElement.querySelector('[data-ctrlIcon]')
      if(icon.classList.contains('fa-pause')) {
        icon.classList.remove('fa-pause');
        icon.classList.add('fa-play');
      }
    })
    song.play(); 
    song.currentTime = progress.value;
    ctrlIcon.classList.add('fa-pause');
    ctrlIcon.classList.remove('fa-play');

    var max = setTimeout(function(){ /* Empty function */ },1);
    for (let i = 1; i < max; i++) {
      window.clearInterval(i);
    }
  
    setInterval(() => {
      progress.value = song.currentTime;
    },300)
    toggleSoundWaveAnimation(waveElm);
}




/*
function toggleSoundWaveAnimation(waveElm) {
  console.log(waveElm)
  const allbars = document.querySelectorAll('.sound-wave .bar');
  const bars = waveElm.querySelectorAll('.sound-wave .bar');
  const bars2 = waveElm.querySelectorAll('.sound-wave .bar2');

   allbars.forEach(bar => {
      bar.classList.remove('animate-bar'); // Remove animation class
  });

  bars.forEach(bar => {
    if (bar.classList.contains('animate-bar')) {
      bar.classList.remove('animate-bar'); // Remove animation class
    } else {
      bar.classList.add('animate-bar');    // Add animation class
    }
  });

  bars2.forEach(bar2 => {
    if (bar2.classList.contains('animate-bar2')) {
      bar2.classList.remove('animate-bar2'); // Remove animation class
    } else {
      bar2.classList.add('animate-bar2');    // Add animation class
    }
  });
}*/
function toggleSoundWaveAnimation(waveElm) {
  console.log("Toggling animation for:", waveElm);

  const allBars = document.querySelectorAll('.sound-wave .bar, .sound-wave .bar2');
  const bars = waveElm.querySelectorAll('.sound-wave .bar');
  const bars2 = waveElm.querySelectorAll('.sound-wave .bar2');

  // Check if the clicked waveElm is currently animating
  const isPlaying = Array.from(bars).some(bar => bar.classList.contains('animate-bar')) ||
                    Array.from(bars2).some(bar2 => bar2.classList.contains('animate-bar2'));

  // Stop all animations first
  allBars.forEach(bar => {
    bar.classList.remove('animate-bar', 'animate-bar2');
  });

  // If the clicked waveElm was not playing, start its animation
  if (!isPlaying) {
    bars.forEach(bar => bar.classList.add('animate-bar'));
    bars2.forEach(bar2 => bar2.classList.add('animate-bar2'));
  }
}

